/**
 * Ramp Panel Store - Manages which slide-out panel is open
 *
 * Only one panel can be open at a time. Panels slide from the left edge
 * and overlay the 3D viewport.
 */

import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export type RampPanel = 'aircraft-list' | 'spaces-list' | 'quick-fit' | 'arrivals'

interface RampPanelState {
  activePanel: RampPanel | null
}

interface RampPanelActions {
  openPanel: (panel: RampPanel) => void
  closePanel: () => void
  togglePanel: (panel: RampPanel) => void
}

export const useRampPanelStore = create<RampPanelState & RampPanelActions>()(
  devtools(
    (set, _get) => ({
      activePanel: null,

      openPanel: (panel) => set({ activePanel: panel }),

      closePanel: () => set({ activePanel: null }),

      togglePanel: (panel) =>
        set((state) => ({
          activePanel: state.activePanel === panel ? null : panel,
        })),
    }),
    { name: 'ramp-panel' }
  )
)
